import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const CONSENT_KEY = 'mnemospeak_cookie_consent';

export const CookieConsent = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const persisted = localStorage.getItem(CONSENT_KEY);
    const sessionDismissed = sessionStorage.getItem(CONSENT_KEY);
    if (!persisted && !sessionDismissed) {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = (type: 'all' | 'essential') => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({ type, date: new Date().toISOString() }));
    setVisible(false);
    if (type === 'all') {
      // Future: initialize analytics here
    }
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-fade-in">
      <div className="container max-w-3xl">
        <div className="rounded-2xl border bg-card p-5 shadow-lg">
          <div className="flex items-start gap-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10">
              <Cookie className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1 space-y-3">
              <div>
                <h3 className="font-heading font-semibold">{t('cookies.title')}</h3>
                <p className="text-sm text-muted-foreground mt-1">
                  {t('cookies.description')}{' '}
                  <Link to="/privacy" className="text-primary hover:underline">{t('cookies.readMore')}</Link>
                </p>
              </div>
              <div className="flex flex-wrap gap-2">
                <Button size="sm" onClick={() => handleAccept('all')}>
                  {t('cookies.acceptAll')}
                </Button>
                <Button size="sm" variant="outline" onClick={() => handleAccept('essential')}>
                  {t('cookies.essentialOnly')}
                </Button>
              </div>
            </div>
            <button
              onClick={() => { sessionStorage.setItem(CONSENT_KEY, 'dismissed'); setVisible(false); }}
              className="shrink-0 text-muted-foreground hover:text-foreground transition-colors"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
